import { CheckCircle2, XCircle } from 'lucide-react';
import { Badge } from '../ui/badge';

export const RuleResults = ({ rules, testPrefix = 'rule' }) => (
    <ul className="space-y-2" data-testid={`${testPrefix}-results`}>
        {rules.map((rule) => {
            const pass = rule.result === 'PASS';
            const Icon = pass ? CheckCircle2 : XCircle;
            return (
                <li
                    key={rule.id}
                    className={`rounded-xl border p-3 ${pass ? 'border-emerald-500/25 bg-emerald-500/5' : 'border-red-500/30 bg-red-500/5'}`}
                    data-testid={`${testPrefix}-${rule.id}`}
                >
                    <div className="flex flex-wrap items-center gap-2">
                        <Icon className={`h-4 w-4 shrink-0 ${pass ? 'text-emerald-600' : 'text-red-600'}`} />
                        <span className={`text-xs font-bold ${pass ? 'text-emerald-700' : 'text-red-700'}`} data-testid={`${testPrefix}-${rule.id}-result`}>
                            {rule.result}
                        </span>
                        <span className="text-sm font-medium">{rule.title}</span>
                        <Badge variant="outline" className="text-[10px] font-normal">{rule.law}</Badge>
                    </div>
                    <p className="mt-1.5 pl-6 text-sm text-muted-foreground">{rule.reason}</p>
                    {rule.quote && (
                        <p className={`mt-1 pl-6 text-sm italic ${pass ? 'text-emerald-800 dark:text-emerald-300' : 'text-red-800 dark:text-red-300'}`}>
                            "{rule.quote}"
                        </p>
                    )}
                </li>
            );
        })}
    </ul>
);
